import React from 'react';

/**
 * Placeholder para seguimientos / follow-up comercial.
 * Sustituir por listado o flujo real cuando exista el backend.
 */
const FollowUpManager = () => (
  <div className="rounded-xl border border-gray-200 bg-white p-8 shadow-sm dark:border-[#3c4043] dark:bg-[#202124]">
    <h2 className="text-xl font-semibold text-gray-900 dark:text-[#e8eaed]">
      Follow UP
    </h2>
    <p className="mt-2 text-sm text-gray-600 dark:text-[#bdc1c6]">
      Esta sección está en preparación. Aquí podrá gestionar el seguimiento de cotizaciones y contactos.
    </p>
  </div>
);

export default FollowUpManager;
